import { render, staticRenderFns } from "./DeveloperFooter.vue?vue&type=template&id=23bd94de&"
import script from "./DeveloperFooter.vue?vue&type=script&lang=ts&"
export * from "./DeveloperFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports